/**
 * Таймер ожидания карточки. Обычная карточка ждёт с первого сообщения клиента.
 * Карточка из нерабочего времени — по настройке автоответчика: без таймера (null) или с начала рабочего времени.
 */
import type { TicketDto } from '@sync-tracker/shared';

export interface OffHoursConfig {
  missedColumnKey: string | null;
  timerFromWorkStart: boolean;
}

/** Момент, с которого идёт ожидание (мс); null — таймера нет (висит с луной, пока не разберут). */
export function timerStartMs(t: TicketDto, cfg: OffHoursConfig | null | undefined): number | null {
  if (!t.offHours) return new Date(t.firstMessageAt).getTime();
  if (!cfg?.timerFromWorkStart) return null;
  return new Date(t.workStartAt ?? t.firstMessageAt).getTime();
}

/** Сколько ждёт открытая карточка (с). null — таймера нет или рабочее время ещё не началось. */
export function openWaitSec(t: TicketDto, now: number, cfg: OffHoursConfig | null | undefined): number | null {
  const start = timerStartMs(t, cfg);
  if (start == null || now < start) return null;
  return (now - start) / 1000;
}

/** Длительность для закрытой карточки и статистики: у карточек из нерабочего времени — от начала рабочего времени. */
export function statStartMs(t: TicketDto): number {
  return new Date((t.offHours && t.workStartAt) || t.firstMessageAt).getTime();
}
